import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BaseFormComponent } from '@classes/extends';
import { InfoClient } from '@composants/composants';
import { Client, ClientsService as ClientService, FicheClient, FicheclientService as FicheClientService, GroupeTech, Installation, RFService, Service } from '@estel-numerique/galaclick-api';
import { DateHelper } from '@estel-numerique/galaclick-core';
import { Constantes } from '@services/util/constantes';
import { lastValueFrom } from 'rxjs';
import { InstallationDetailsComponent, InstallationDetailsComponentData } from 'src/app/installation/installation.component';
import { ServiceDetailsComponent, ServiceDetailsComponentData } from 'src/app/suiviclients/services/services-details/services-details.component';
import { ClientDetailsComponent } from '../../../suiviclients/clients.component';
import { InventaireComponent, InventaireComponentData } from '../../../suiviclients/inventaire.component';
import { FicheClientDonneesGenComponent } from '../ficheclient-donneesgen/ficheclient-donneesgen.component';
import { FicheClientGroupesComponent } from '../ficheclient-groupes/ficheclient-groupes.component';
import { FicheClientRacesComponent } from '../ficheclient-races/ficheclient-races.component';
import { FicheClientSurfacesComponent } from '../ficheclient-surfaces/ficheclient-surfaces.component';
import { DialogGalaComponent } from '../../../composants/dialog-gala/dialog-gala.component';
import { InfoClient as InfoClient_1 } from '../../../composants/composants';
import { ButtonGalaComponent } from '../../../composants/buttons/btn-gala/btn-gala.component';
import { ButtonGalaEditComponent } from '../../../composants/buttons/btn-gala-edit/btn-gala-edit.component';
import { ButtonGalaSearchComponent } from '../../../composants/buttons/btn-gala-search/btn-gala-search.component';
import { AccordionGalaComponent } from '../../../composants/accordion-gala/accordion-gala.component';
import { AccordionGalaItemComponent } from '../../../composants/accordion-gala/accordion-gala-item/accordion-gala-item.component';
import { AccordionGalaItemHeadComponent } from '../../../composants/accordion-gala/accordion-gala-item-head/accordion-gala-item-head.component';
import { AccordionGalaItemBodyComponent } from '../../../composants/accordion-gala/accordion-gala-item-body/accordion-gala-item-body.component';
import { MatButton } from '@angular/material/button';


/**
  * Page des plans de tournée
  */
@Component({
    templateUrl: './ficheclient-details.component.html',
    imports: [
        DialogGalaComponent, InfoClient_1, ButtonGalaComponent, ButtonGalaEditComponent, ButtonGalaSearchComponent, AccordionGalaComponent, AccordionGalaItemComponent,
        AccordionGalaItemHeadComponent, AccordionGalaItemBodyComponent, FicheClientDonneesGenComponent, FicheClientGroupesComponent, FicheClientSurfacesComponent, FicheClientRacesComponent,
        MatButton
    ]
})
export class FicheClientDetailsComponent extends BaseFormComponent implements OnInit {

    private wsClient = inject(ClientService);
    private wsFicheClient = inject(FicheClientService);
    private dialog = inject(MatDialog);
    private dialogRef = inject<MatDialogRef<FicheClientDetailsComponent>>(MatDialogRef);
    public data = inject<Client>(MAT_DIALOG_DATA);

    public codeModule: string = Constantes.CodeOption.CFICHECLIENT; // Code module/option testé pour vérifier l'accès à cette fonction (si null = OK)
    public titre: string;

    @ViewChild('infosClient', { static: true }) public infosClient: InfoClient;
    @ViewChild('donneesGen') public compDonneesGen: FicheClientDonneesGenComponent;
    @ViewChild('groupes') public compGroupes: FicheClientGroupesComponent;
    @ViewChild('surfaces') public compSurfaces: FicheClientSurfacesComponent;
    @ViewChild('races') public compRaces: FicheClientRacesComponent;

    protected lgTrad: Record<string, string> = {};

    public client: Client;
    public ficheClient: FicheClient;

    protected accesSuiviActivite = false;

    constructor() {
        super();
        this.dialogRef.updateSize('1130px');
        this.lgTrad = {
            ENR: this.translate.instant("ENR"),
            RET: this.translate.instant("RET"),
            APPLIQUER: this.translate.instant("APPLIQUER"),
            DELETE: this.translate.instant("DELETE"),
            CONSULT: this.translate.instant("CONSULT"),
            MODIF: this.translate.instant("MODIF"),
            CREA: this.translate.instant("CREA"),
            GENEDATAS: this.translate.instant("GENEDATAS"),
            TITRE: this.translate.instant("APPFICHECLIENT.TITRE"),
            GROUPES: this.translate.instant('APPFICHECLIENT.GROUPES'),
            SURFACES: this.translate.instant('APPFICHECLIENT.SURFACES'),
            RACES: this.translate.instant('APPFICHECLIENT.RACES'),
        };
    }

    ngOnInit() {
        super.ngOnInit();
        this.showFromClient(this.data).catch(e => this.util.fErreur(e));
        this.accesSuiviActivite = this.ctrlAccess.ctrlAccessOK(Constantes.CodeOption.CSUIVIACTCLIENT);

    }

    // =========================================================================
    // CHARGEMENT CONTEXTE
    // =========================================================================

    private async chargeDonnees(IDCLIENT: number) {
        try {
            this.ficheClient = await lastValueFrom(this.wsFicheClient.getClientDetails(IDCLIENT));

            await this.compDonneesGen.initialiseDonneesGenerales(this.ficheClient.DONNEESGEN, IDCLIENT);
            this.compGroupes.initialiseGroupes(this.ficheClient.GROUPES, IDCLIENT);

            await this.compSurfaces.initialiseSurfaces(this.ficheClient.SURFACES, IDCLIENT);
            this.compRaces.initialiseRaces(this.ficheClient.RACES, IDCLIENT);

            if (this.client.DATEFINCONTRATSIG) {
                this.util.fInfo(`Données IPG clôturées pour ce client le ${(DateHelper.fConvDateFR(this.client.DATEFINCONTRATSIG))}`);
            }
        } catch (e) {
            console.error(e);
            throw e;
        }
    }

    private async showFromClient(client: Client) {
        if (!client.REFERENT && (!client.CONTACTS || client.CONTACTS.length === 0)) {
            // dans ce cas le client n'est pas complet et on le récupère avec les infos manquantes.
            this.client = await this.wsClient.getClientByNuchep(client.NUCHEP).toPromise();
        } else {
            this.client = client;
        }
        await this._show(client.IDCLIENT);
    }

    private async _show(IDCLIENT: number) {
        this.util.showLoader();
        try {
            await this.chargeDonnees(IDCLIENT);
        } catch (e) {
            this.util.fErreur(e);
        } finally {
            this.util.hideLoader();
        }
    }


    public hideModal() {
        if (this.checkIfHasFavorite()) {
            this.dialogRef.close();
        } else {
            this.util.fErreur(this.translate.instant('APPFICHECLIENT.ERRORFAVFICHE'));
        }
    }

    public checkIfHasFavorite() {
        let hasServiceBilan = false;
        this.ficheClient?.DONNEESGEN?.SERVICES?.forEach((service: Service) => {
            if (service.TYPESERVICE.CODESERV == "BLN") {
                hasServiceBilan = true;
            }
        });
        if (hasServiceBilan) {
            let hasFavori = false;
            this.ficheClient?.GROUPES?.GROUPESTECH?.forEach((groupe: GroupeTech) => {
                if (groupe.FAVORI == 1) {
                    hasFavori = true;
                }
            });
            if (hasFavori) {
                return true;
            }
            return false;
        }
        return true;
    }

    /**
     * Permet d'ouvrir la fenêtre de l'option choisie (inventaire, suivi activé ou modification)
     */
    public nouvellePage($event: number) {
        if ($event == 1) {
            // inventaire
            this.dialog.open(InventaireComponent, {
                data: {
                    copaip: 'FR',
                    nuchep: this.client.NUCHEP,
                    idClient: this.client.IDCLIENT
                } as InventaireComponentData
            });
        } else if ($event == 2) {
            // suivi activité
            this.router.navigate(['/suiviactivite', 'client', this.client.IDCLIENT]).catch(e => this.util.fErreur(e));
            this.hideModal();
        } else if ($event == 3) {
            // détail client
            const dialogDetail = this.dialog.open(ClientDetailsComponent, { data: this.client });
            dialogDetail.componentInstance.BDDChanges.subscribe((clientSaved) => {
                this.savedClient(clientSaved).catch(e => this.util.fErreur(e));
            });
        }
    }

    /**
     * Méthode permettant de sélectionné le service qu'on veut créer et d'ouvrir la fenêtre correspondante
     */
    public openService(rfService: RFService) {
        if (this.droitsAccess.write) {
            const service: Service = {
                TYPESERVICE: rfService,
                CLIENT: {
                    IDCLIENT: this.client.IDCLIENT
                },
                NUCHEP: this.client.NUCHEP
            };
            this.openEditService(service);
        }
    }

    /**
     * Méthode permettant d'afficher la fenêtre de modification d'un service en récupérant ses données
     */
    openEditService(service: Service) {
        const dialService = this.dialog.open(ServiceDetailsComponent, {
            data: {
                service: service,
                client: this.client
            } as ServiceDetailsComponentData
        });
        dialService.componentInstance.saved.subscribe((serv) => {
            this.savedService(serv);
        });
    }

    /**
     * Méthode d'ouverture de la modale des installations
     */
    openInstallations() {
        const dialogInstallation = this.dialog.open(InstallationDetailsComponent, {
            data: {
                client: this.client
            } as InstallationDetailsComponentData
        });
        dialogInstallation.componentInstance.deleteInstallation.subscribe((install) => {
            this.deletedInstall(install);
        });
        dialogInstallation.componentInstance.saveInstallation.subscribe((install) => {
            this.savedInstall(install);
        });
    }

    public savedInstall(installation: Installation) {
        const index = this.ficheClient.DONNEESGEN.INSTALLATIONS.findIndex((i: Installation) => {
            return i.IDINSTALL == installation.IDINSTALL;
        });
        if (index > -1) {
            if (!this.util.date.compareTodayDate(installation.DDEBUT, installation.DFIN, false)) {
                this.ficheClient.DONNEESGEN.INSTALLATIONS.splice(index, 1);
            } else {
                this.ficheClient.DONNEESGEN.INSTALLATIONS.splice(index, 1, installation);
            }
        } else {
            this.ficheClient.DONNEESGEN.INSTALLATIONS.push(installation);
        }
    }

    public deletedInstall(installation: Installation) {
        this.ficheClient.DONNEESGEN.INSTALLATIONS.splice(this.ficheClient.DONNEESGEN.INSTALLATIONS.findIndex((i: Installation) => {
            return i.IDINSTALL == installation.IDINSTALL;
        }), 1);
    }

    public savedService(service: Service) {
        const index = this.ficheClient.DONNEESGEN.SERVICES.findIndex((s: Service) => {
            return s.IDSERVICE == service.IDSERVICE;
        });
        if (index > -1) {
            if (!this.util.date.compareTodayDate(service.DDEBUT, service.DFIN, false)) {
                this.ficheClient.DONNEESGEN.SERVICES.splice(index, 1);
            } else {
                this.ficheClient.DONNEESGEN.SERVICES.splice(index, 1, service);
            }
        } else {
            this.ficheClient.DONNEESGEN.SERVICES.push(service);
        }
    }

    public async savedClient(client: Client) {
        if (client != null) {
            this.client = client;
            await this.infosClient.chargerDonnees(true);
        }
    }

}
